import React from 'react'
import { ArrowIcon } from 'packages/eid-icons'
import { EidAutocomplete } from 'packages/eid-controls'
import { useTranslation } from 'react-i18next'
import config from 'config'
import { imagesDisabled } from 'utils'

const OptionComponent = EidAutocomplete.getOptionComponent({
    type: 'person',
    cdnUrl: config.BASE_EID_URL,
    disableImage: imagesDisabled,
})

const getOptionLabel = (option) => option.friendlyName

const advancedSearchColumns = [
    { name: 'FriendlyName', type: 'string' },
    { name: 'Login', type: 'string' },
    { name: 'Email', type: 'string' },
]

function PeopleSearch({
    value,
    labelKey = 'SomeoneElse',
    url = '/api/people',
    excludeOptions,
    placeholder,
    searchAdvanced = true,
    queryParams = {},
    ...rest
}) {
    const { t } = useTranslation()
    return (
        <EidAutocomplete.New
            label={t(labelKey)}
            placeholder={t(placeholder ? placeholder : 'SelectPerson')}
            url={url}
            queryParams={{
                take: 10,
                ...queryParams,
            }}
            dedupingInterval={60000}
            value={value ? value : null}
            getOptionLabel={getOptionLabel}
            endAdornmentComponent={() => (
                <ArrowIcon direction="right" color="#453fbb" />
            )}
            optionComponent={OptionComponent}
            excludeOptions={excludeOptions}
            advancedSearchColumns={searchAdvanced ? advancedSearchColumns : []}
            {...rest}
        />
    )
}

export default PeopleSearch
